import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import SoftwareUpdatesWithFeature from '../../components/SoftwareUpdates/SoftwareUpdatesWithFeature';
import useFeature from '../../components/SystemSettings/hooks/featureFlags/useFeature';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import EnvironmentOverview from '../../components/SoftwareUpdates/v2/EnvironmentOverview';

export const SoftwareUpdatesRouting = (props: LogicalRouteImportProps) => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const disabled = !useHasPermissions({ permission: Pages.SOFTWARE_UPDATES, role: Roles.VIEWER });
    if (systemMode === SYSTEM_MODES.SAAS || systemMode === SYSTEM_MODES.SAAS_SUPPORT) {
        return <LogicalRoute {...props} component={SoftwareUpdatesWithFeature} disabled={disabled} />;
    } else {
        return <LogicalRoute {...props} component={EnvironmentOverview} disabled={disabled} />;
    }
};
